import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http'; 
import { Observable } from 'rxjs';
import { navmenu } from './nav-menu';
import { environment } from '../../environments/environment';

@Injectable()
export class navmenuservices {
  constructor(private http: HttpClient) {
  }
  headers = new Headers({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
    'Access-Control-Allow-Headers': '*'
  });
  baseUrl: string = environment.serviceUrl;

  postdata(userid:any): Observable<any> {
    
    return this.http.post(
      this.baseUrl + 'api/NavmenuApi/getmappedmenu/' + userid, {userid}

    );
  }

  getmenulist(userid:any): Observable<any> {
    
    return this.http.post(
      this.baseUrl + 'api/NavmenuApi/getmenulist/' + userid, {userid}

    );
  }

  getdata(userid: any, url): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'text',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'Get',
        'Access-Control-Allow-Headers': 'x-requested-with'
      })
    };
    return this.http.get(this.baseUrl + url + userid, headers);
  }

}
